import { Box } from '@customerio/pluma-components/react';

/** Plan-choice step. Placeholder — content lands with the plan-choice step PR. */
export function PlanChoiceStep() {
  return <Box data-testid="signup-step-plan-choice" />;
}
